module.exports = __webpack_public_path__ + "img/2.1_Russian_road_sign.a399408c.svg";